export default __webpack_public_path__ + "static/media/GalanoGrotesque-Heavy.528c9ed2.ttf";